import { Text, View } from "@react-pdf/renderer";
import { FunctionComponent } from "react";

type Props = {
  totalGold?: number | null;
  totalSilver?: number | null;
  totalHechura?: string;
  totalQuantity: number;
};

const TotalsItems: FunctionComponent<Props> = ({
  totalQuantity,
  totalGold,
  totalSilver,
  totalHechura,
}) => (
  <View
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "baseline",
      fontSize: "10px",
      width: "100%",
      fontFamily: "Mont-Regular",
      paddingBottom: "20px",
      paddingTop: "20px",
      backgroundColor: "#F5F5F5",
      marginTop: "42px",
      position: "relative",
    }}
  >
    <Text
      style={{
        width: "25%",
        textAlign: "center",
        color: "#3E3B4C",
        fontFamily: "Mont-Bold",
      }}
    >
      Total del pedido:
    </Text>
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        position: "relative",
        right: "9rem",
        top: "9rem",
      }}
    >
      <Text
        style={{
          width: "25%",
          textAlign: "center",
          color: "#3E3B4C",
        }}
      >
        {totalQuantity ? "Cantidad: " : null}
        <Text
          style={{
            textAlign: "center",
            color: "#3E3B4C",
            fontFamily: "Mont-Bold",
          }}
        >
          {totalQuantity ? totalQuantity : null}
        </Text>
      </Text>
      <Text
        style={{
          width: "25%",
          textAlign: "center",
          color: "#3E3B4C",
        }}
      >
        {totalGold ? "Oro: " : null}
        <Text
          style={{
            textAlign: "center",
            color: "#3E3B4C",
            fontFamily: "Mont-Bold",
          }}
        >
          {totalGold ? totalGold + " gr" : null}
        </Text>
      </Text>
      <Text
        style={{
          width: "25%",
          textAlign: "center",
          color: "#3E3B4C",
        }}
      >
        {totalSilver ? "Plata: " : null}
        <Text
          style={{
            textAlign: "center",
            color: "#3E3B4C",
            fontFamily: "Mont-Bold",
          }}
        >
          {totalSilver ? totalSilver + " gr" : null}
        </Text>
      </Text>

      <Text
        style={{
          width: "25%",
          textAlign: "center",
          color: "#3E3B4C",
        }}
      >
        Hechura:{" "}
        <Text
          style={{
            textAlign: "center",
            color: "#3E3B4C",
            fontFamily: "Mont-Bold",
          }}
        >
          {totalHechura}
        </Text>
      </Text>
    </div>
  </View>
);

export default TotalsItems;
